/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knotty_Dry_Owl_TrustInputs */

const fr_knotty_dry_owl_trust = /** @type {(inputs: Knotty_Dry_Owl_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit`)
};

/**

* @param {Knotty_Dry_Owl_TrustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const knotty_dry_owl_trust = /** @type {((inputs?: Knotty_Dry_Owl_TrustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knotty_Dry_Owl_TrustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_knotty_dry_owl_trust(inputs)
});